export default __webpack_public_path__ + "static/media/Illiquiq_banner.7adad875.png";